import { ErrorResponseBody } from '../models/ErrorResponseBody';

export interface ResponseProps {
  status: number;
  statusText: string;
  url: string;
}

export interface ExtendedError {
  message: string;
  name: string;
  stack?: string;
  userReadableMessage?: string;
  response?: ResponseProps;
  body?: ErrorResponseBody;
}

export default class HttpError extends Error implements ExtendedError {
  public response: ResponseProps;
  public userReadableMessage?: string;
  public body?: ErrorResponseBody;

  constructor(response: ResponseProps, userReadableMessage?: string, body?: ErrorResponseBody) {
    super();
    this.response = response;
    this.message = JSON.stringify(response);
    this.userReadableMessage = userReadableMessage;
    this.body = body;
  }
}
